import { Layout } from 'components'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { createNewUser, getPositionData } from 'service/AdminService'
import {
    postRegisterUser,
    setPositionById,
} from 'store/slices/AdminSlice'
import Notification from 'utils/Notifications'
import styles from './RegisterForm.module.scss'
import { ScaleLoader } from 'react-spinners'
import { useEffect } from 'react'
import { getCurrentDate } from 'utils/todayDateForInput'
const RegisterForm = () => {
  const { t } = useTranslation('common')
  const [loader, setLoader] = useState(false)


  const [gender, setGender] = useState(null)
  const [first_name, setFirst_name] = useState('')
  const [last_name, setLast_name] = useState('')
  const [middle_name, setMiddle_name] = useState('')
  const [data_of_birth, setData_of_birth] = useState('')
  const [number_phone, setNumber_phone] = useState('')
  const [email, setEmail] = useState('')


  const [inn, setInn] = useState(null)


  const [notify, setNotify] = useState({
    isOpen: false,
    message: '',
    type: '',
  })
  const dispatch = useDispatch()
  const getData = async () => {
    let data
    try {
      let response = await getPositionData(data)

      dispatch(
        setPositionById({
          position: response.data,
        }),
      )
    } catch (error) {
    }
  }

  useEffect(() => {
    getData()
  }, [])
  const handleSubmit = async (event) => {
    event.preventDefault()
    if (loader) return
    if (
      !gender ||
      !first_name ||
      !last_name ||
      !middle_name ||
      !data_of_birth ||
      !number_phone ||
      !email ||
      !inn
    ) {
      setNotify({
        isOpen: true,
        message: t('common.fill_all_fields'),
        type: 'warning',
        sound: 'warning',
      })
      return
    }
    try {
        setLoader(true)
        // Wave Final (P0-8): пароль = ИНН — критическая уязвимость (ИНН публичен).
        // Генерируем 24-символьный криптостойкий пароль на клиенте через WebCrypto.
        // Бэкенд должен взять контроль над этим (issue tracking) — отправлять
        // одноразовый пароль на email/SMS; до тех пор фронт даёт неугадываемый.
        const generatePassword = () => {
          const alphabet =
            'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789!@#$%^&*'
          const bytes = new Uint8Array(24)
          ;(window.crypto || window.msCrypto).getRandomValues(bytes)
          return Array.from(bytes, (b) => alphabet[b % alphabet.length]).join('')
        }
        const password = generatePassword()
        let response = await createNewUser(
          gender,
          first_name,
          last_name,
          middle_name,
          data_of_birth,
          number_phone,
          email,
          inn,
          password,
        )
        dispatch(
          postRegisterUser({
            gender,
            first_name,
            last_name,
            middle_name,
            data_of_birth,
            number_phone,
            email,
            inn,
            password,
          }),
        )
        setNotify({
          isOpen: true,
          message: t('user.user_added'),
          type: 'success',
          sound: 'success',
        })
        setGender(null)
        setFirst_name('')
        setLast_name('')
        setMiddle_name('')
        setData_of_birth('')
        setNumber_phone('')
        setEmail('')
        setInn(null)
      } catch (error) {

        setNotify({
          isOpen: true,
          message: t('common.error'),
          type: 'error',
          sound: 'error',
        })
      } finally {
        setLoader(false)
      }
  }


  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.title}>{t('user.user_register_title')}</div>
        <form onSubmit={handleSubmit} noValidate>
          <span className={styles.gender_title}>{t('user.select_gender')} </span>
          <div className={styles.gender_details}>
            <div style={{ display: 'flex' }}>
              <input
                style={{
                  height: '18px',
                  width: '18px',
                  background: '#d9d9d9',
                  borderRadius: '50%',
                  marginRight: '10px',
                  border: '5px solid transparent',
                }}
                type="radio"
                name="gender"
                id="dot-1"
                value="Мужчина"
                checked={gender === 'Мужчина'}
                onChange={() => setGender('Мужчина')}
                required
              />
              <label htmlFor="dot-1" className={styles.gender}>{t('user.male')}</label>
            </div>
            <div style={{ display: 'flex' }}>
              <input
                style={{
                  height: '18px',
                  width: '18px',
                  background: '#d9d9d9',
                  borderRadius: '50%',
                  marginRight: '10px',
                  border: '5px solid transparent',
                }}
                type="radio"
                name="gender"
                id="dot-2"
                value="Женщина"
                checked={gender === 'Женщина'}
                onChange={() => setGender('Женщина')}
                required
              />
              <label htmlFor="dot-2" className={styles.gender}>{t('user.female')}</label>
            </div>
          </div>

          <div className={styles.user_details}>
          <div className={styles.input_pox}>
              <label className={styles.datails} htmlFor="reg-last-name">{t('user.last_name')}</label>
              <input
                id="reg-last-name"
                type="text"
                autoComplete="family-name"
                placeholder={t('user.enter_last_name')}
                value={last_name}
                onChange={(e) => setLast_name(e.target.value)}
                required
              />
            </div>
            <div className={styles.input_pox}>
              <label className={styles.datails} htmlFor="reg-first-name">{t('user.first_name')}</label>
              <input
                id="reg-first-name"
                type="text"
                autoComplete="given-name"
                placeholder={t('user.enter_first_name')}
                value={first_name}
                onChange={(e) => setFirst_name(e.target.value)}
                required
              />
            </div>

            <div className={styles.input_pox}>
              <label className={styles.datails} htmlFor="reg-middle-name">{t('user.middle_name')}</label>
              <input
                id="reg-middle-name"
                type="text"
                autoComplete="additional-name"
                placeholder={t('user.enter_middle_name')}
                value={middle_name}
                onChange={(e) => setMiddle_name(e.target.value)}
                required
              />
            </div>
            <div className={styles.input_pox}>
              <label className={styles.datails} htmlFor="reg-birth-date">{t('user.birth_date')}</label>
              <input
                id="reg-birth-date"
                type="date"
                autoComplete="bday"
                placeholder={t('user.enter_birth_date')}
                value={data_of_birth}
                max={getCurrentDate()}
                onChange={(e) => setData_of_birth(e.target.value)}
                required
              />
            </div>
            <div className={styles.input_pox}>
              <label className={styles.datails} htmlFor="reg-phone">{t('user.phone')}</label>
              <input
                id="reg-phone"
                type="tel"
                inputMode="numeric"
                pattern="[0-9]*"
                autoComplete="tel"
                placeholder={t('user.enter_phone')}
                value={number_phone}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '')
                  setNumber_phone(value)
                }}
                required
              />
            </div>
            <div className={styles.input_pox}>
              <label className={styles.datails} htmlFor="reg-email">{t('user.email')}</label>
              <input
                id="reg-email"
                type="email"
                autoComplete="email"
                placeholder={t('user.enter_email')}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>


            <div className={styles.input_pox}>
              <label className={styles.datails} htmlFor="reg-inn">{t('auth.inn')}</label>
              <input
                id="reg-inn"
                type="text"
                inputMode="numeric"
                pattern="[0-9]*"
                autoComplete="username"
                placeholder={t('user.enter_inn')}
                value={inn ?? ''}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '')
                  setInn(value)
                }}
                required
              />
            </div>




          </div>
          {loader ? (
            <ScaleLoader color="black" size={30} />
          ) : (
            <div className={styles.button}>
              <button
                type="submit"
                disabled={loader}
              >
                {t('user.add_to_team')}
              </button>
            </div>
          )}

        </form>
      </div>
      <Notification notify={notify} setNotify={setNotify} />
    </Layout>
  )
}

export default RegisterForm
